import * as Sentry from '@sentry/vue'

/**
 * Breadcrumbs for IndexedDB asset cache health (purge / MIME repair / full scan).
 * In Sentry Issues, open Breadcrumbs and filter category `player_asset_cache`.
 */
export function addPlayerAssetCacheSentryBreadcrumb(payload: Record<string, unknown>): void {
  try {
    const phase = typeof payload.phase === 'string' ? payload.phase : 'event'
    Sentry.addBreadcrumb({
      category: 'player_asset_cache',
      message: phase,
      level: phase === 'purge' ? 'warning' : 'info',
      data: payload
    })
  }
  catch {
    /* Sentry not initialized or unavailable */
  }
}
